import './MarketSlider.css';const s = "_slider_2ec68ed", t = "_input_b5d798a", e = { slider: s, input: t };
export {
  e as default
};
